exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table a[data-v-12d03eb7] {\n  text-decoration: underline;\n}\na[data-v-12d03eb7] {\n  text-decoration: underline;\n}\n.sub-table[data-v-12d03eb7] {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  width: 100%;\n  border: 1px solid #d7d8da;\n}\n.sub-table td[data-v-12d03eb7],\n.sub-table th[data-v-12d03eb7] {\n  border: 1px solid #ccc;\n  padding: 0.5rem;\n}\n.personal-deductions .col[data-v-12d03eb7] {\n  width: 150px;\n}\n.personal-deductions .amount[data-v-12d03eb7] {\n  width: 150px;\n  text-align: right;\n}\n.invoices-table th[data-v-12d03eb7],\n.invoices-table td[data-v-12d03eb7] {\n  font-size: 12px;\n}", ""]);

// exports
